/* eslint-disable no-mixed-operators */
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import "./CardTurnoAgreement.css";
import "./CardTurnoAlerts.css";
import Tooltip from "../../../../global/component/Genericos/Tooltip/Tooltip";
import AlertIcon from "../../../assets/images/generico/AlertIcon";

const CardTurnoAgreement = () => {
  const {
    textosState,
  } = useContext(PortalContext);


  return <div className="ptur-card-cardTurno-agreement">
    <div className="ptur-alert ptur-button">
      <Tooltip
        descripcion={textosState.textos.data?.compromisoTurno?.descripcion}
        data={
          <div className="message c-primary">
            <AlertIcon color="var(--color-primary)" />
            <span>
              Tu compromiso reservando turnos
            </span>
          </div>
        }
        customCss="tooltip-max"
      />
    </div>
  </div>;
};

export default CardTurnoAgreement;
